import { SxProps, Theme } from "@mui/material";

export const sx = {
  listItemIcon: {
    minWidth: 32,
  } as SxProps<Theme>,

  closeButton: {
    textTransform: "none",
  } as SxProps<Theme>,
};
